<!-- <template>
    <div>
        <v-container fluid>
            <div class="d-flex mb-4">
                <h2>{{ $t("Enquiries") }}</h2>
                <v-spacer></v-spacer>
                <template>
                    <div>
                        <v-btn 
                            color="primary"
                            dark 
                            depressed
                            @click="$router.push({name: 'Enquiries'})"
                            outlined
                        >
                        Back
                        </v-btn>
                    </div>
                </template>
            </div>
        </v-container>
    </div>
</template> -->

<template>
    <div class="chat-container mx-4" ref="chatWindowRef">
        <div class="d-flex mb-4 mx-4">
            <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title>
                        <h3>
                            {{ enquiry.subject || '' }}
                            <span>#{{ enquiry.id}}</span>
                            <span class="ml-4 primary--text">{{
                            enquiry.status
                            }}</span>
                        </h3>
                    </v-list-item-title>
                    <v-list-item-subtitle class="mt-2 description-header">{{
                        enquiry.description
                    }}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-spacer></v-spacer>
            <v-btn
            color="primary"
            outlined
            dark
            small
            class="mr-2"
            @click="$router.push({name: 'Enquiries'})"
            >
            {{ $t('back') }}
            </v-btn>
        </div>
        <v-card elevation="0" min-height="500" class="pa-5 chat-box">
            <v-list three-line>
                <v-list-item
                    v-for="(item, index) in messages"
                    :key="index"
                    class=" mb-5 rounded-lg py-1"
                    :class="item.sent ? 'justify-end text-right secondary2light' : 'primary'"
                >
                    <div v-if="!item.sent" class="d-flex">
                        <v-list-item-avatar>
                            <v-img :src="item.avatar"></v-img>
                        </v-list-item-avatar>
        
                        <v-list-item-content style="background-color: 'CCF2E3'">
                            <v-list-item-subtitle
                            v-if="item.comment"
                            v-text="formatDateTime(item.createdAt)"
                            >
                            </v-list-item-subtitle>
                            <v-list-item-subtitle
                            v-html="item.comment"
                            class="message-received"
                            >
                            </v-list-item-subtitle>
                            <v-list-item-subtitle
                            v-if="item.file_url"
                            v-text="formatTime(item.createdAt)"
                            ></v-list-item-subtitle>
                            <v-img
                            max-height="100"
                            max-width="200"
                            :src="item.file_url"
                            ></v-img>
                        </v-list-item-content>
                    </div>
            <div v-else class="d-flex float-right">
              <v-list-item-content class="justify-end">
                <v-list-item-subtitle
                  v-if="item.comment"
                  v-text="formatDateTime(item.createdAt)"
                >
                </v-list-item-subtitle>
                <v-list-item-subtitle
                  v-html="item.comment"
                  class="message-sent"
                  v-if="item.comment"
                >
                </v-list-item-subtitle>
                <v-list-item-subtitle
                  v-if="item.file_url"
                  v-text="formatTime(item.createdAt)"
                ></v-list-item-subtitle>
                <v-img
                  class="img1"
                  max-height="100"
                  max-width="150"
                  v-if="item.file_url"
                  :src="item.file_url"
                ></v-img>
              </v-list-item-content>
            </div>
          </v-list-item>
            </v-list>
  
            <v-card-actions style="position:absolute;bottom:0;width: 85%;" class="d-flex">     
                <v-text-field
                    placeholder="Type your message here"
                    v-model="chatMessage"
                    outlined
                    dense
                    hide-details="auto"
                    filled
                
                >
        
                <template #append>
                    <div style="width: 30px">
                    <label style="white-space: nowrap" for="file-input">
                        <v-icon>mdi-paperclip</v-icon>
                    </label>
        
                    <input
                        type="file"
                        id="file-input"
                        name="file-input"
                        accept="image/*"
                        style="display: none"
                        @change="onFileChanged"
                    />
                    </div>
                    {{ selectedFile ? selectedFile.name : "" }}
                </template>
                <template v-slot:append-outer>
                    <v-btn
                        @click="sendMessage"
                        color="primary"
                        class="mt-n2"
                        min-height="40"
                        max-width="40"
                    >
                        <v-icon>mdi-send</v-icon>
                    </v-btn>
                </template>
                </v-text-field>
            </v-card-actions>
      </v-card>
    </div>
  </template>
  
  <script>
  import axios from "axios"
  import EnquiryService from "@/_services/EnquiryService";

  export default {
    data () {
      return {
        chatMessage: "",
        messages: [],
        selectedFile: null,
        enquiry: null,
      }
    },
    methods: {
        async getEnquiry() {
            this.enquiry = await EnquiryService.getEnquiry(this.$route.params.id);
        },
      async getComments() {
        const res = await axios.get(
          `enquiry/comments/${this.$route.params.id}`
        );
        if (res.data.success) {
          this.messages = res.data.data.sort(function (a, b) {
            var keyA = new Date(a.id),
              keyB = new Date(b.id);
       
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
          });
        }
        // console.log("messages --> ", this.messages);
      },
      async sendMessage() {
        let formData = new FormData();
        if (this.selectedFile) {
            if (
                this.selectedFile["type"] === "image/jpeg" ||
                this.selectedFile["type"] === "image/jpg" ||
                this.selectedFile["type"] === "image/png"
            ) {
                formData.append("file", this.selectedFile);
            }
        }
        if (this.chatMessage !== "" || this.selectedFile) {
            const res = await axios.post(
                `enquiry/comments?ticketId=${this.$route.params.id}&comment_type=string&comment=${this.chatMessage}`,
                formData,
                {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                }
            );
          // console.log("res is ", res);
          if (res.data.success) {
            this.getComments();
            this.selectedFile = null;
            this.chatMessage = "";
          }
        }
      },
      onFileChanged(e) {
        this.selectedFile = e.target.files[0] || e.dataTransfer.files;
  
        if (
          !this.selectedFile ||
          this.selectedFile.type === "application/x-zip-compressed"
        )
          return;
        console.log(this.selectedFile);
      },
      formatTime(date) {
        const d = new Date(date);
        let month = "" + (d.getMonth() + 1);
        let day = "" + d.getDate();
        // const year = d.getFullYear();
  
        if (month.length < 2) {
          month = "0" + month;
        }
        if (day.length < 2) {
          day = "0" + day;
        }
  
        const hours = d.getHours();
        let minutes = d.getMinutes();
        minutes = minutes < 10 ? "0" + minutes : minutes;
        const strTime = hours + ":" + minutes;
  
        return strTime;
      },
      formatDateTime(date) {
        const d = new Date(date);
        let month = "" + (d.getMonth() + 1);
        let day = "" + d.getDate();
        const year = d.getFullYear();
  
        if (month.length < 2) {
          month = "0" + month;
        }
        if (day.length < 2) {
          day = "0" + day;
        }
  
        const hours = d.getHours();
        let minutes = d.getMinutes();
        minutes = minutes < 10 ? "0" + minutes : minutes;
        const strTime = hours + ":" + minutes;
  
        return [year, month, day].join("-") + " " + strTime;
      },
    },
    created () {
        this.getEnquiry();
        this.getComments()
    }
  }
  </script>
  
  <style>
  
  </style>